<template>
  <div class="rules-container" v-if="orderobj">
    <Modal
      title
      v-model="showRefoundInfo_new"
      @on-cancel="close"
      width="800"
      class-name="vertical-center-modal rules-modal"
    >
      <div class="header">
        退款信息
        <Icon @click="close" type="md-close" />
      </div>
      <div class="package-info">
        <div class="package-list">
          <div
            @click="changePackage(index,item)"
            :class="['package',refoundIndex== index ? 'active':'']"
            v-for="(item,index) in refundList"
            v-if="refundList.length>1"
            :key="index"
          >
            退款单
            <span>{{index+1}}</span>
          </div>
        </div>
        <div class="content">
          <div v-if="orderobj.status == 2">
            <div class="status">
              <img class="status-icon" src="../../assets/image/icon/success-info.svg" />
              退款成功
            </div>
            <div class="text">商家已在{{refunddate}}完成退款</div>
          </div>
          <div v-else-if="orderobj.status == 1">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/error-info.svg" />退款处理中
              </div>
            </div>
            <div class="text">您的退款正在处理中，请耐心等待</div>
          </div>
          <div v-else-if="orderobj.status == 3">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/error-info.svg" />撤销退款
              </div>
            </div>
            <div class="text">你的退款已经撤销</div>
          </div>
          <div v-else-if="orderobj.status == 4">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/error-info.svg" />退款失败
              </div>
            </div>
            <div class="text">请联系客服查询退款失败原因</div>
          </div>
        </div>
      </div>
      <div class="good-list">
        <div class="cart-item" v-for="(item,index) in orderobj.list" :key="index">
          <div class="cart-left">
            <div class="cart-img">
              <img :src="item.url" />
            </div>

            <div class="cart-info">
              <div class="cart-info-detail">
                <div class="good-name">
                  <span>{{item.name}}</span>
                </div>
                <div class="good-size">
                  尺码.
                  <span
                    class="value"
                    v-for="(v, i) in item.specType"
                    :key="i"
                  >{{v}}{{i!=item.specType.length-1?'；':''}}</span>
                </div>
                <div class="good-color">
                  颜色.
                  <span class="value">{{item.colorText}}</span>
                </div>
                <div class="good-num">
                  数量.
                  <span class="value">{{item.refundNum}}</span>
                </div>
              </div>
              <div class="cart-price">
                <div class="all-price">
                  <span class="price1" v-if="item.discountPrice">¥{{$utils.toThousands(item.price)}}</span>
                </div>
                <!-- <div class="tips value">已退款</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="refound-info">
        <div class="item">
          <div class="label">退款类型</div>
          <div class="value">{{orderobj.refundType==0?'仅退款':'退货退款'}}</div>
        </div>
        <div class="item">
          <div class="label">退款金额</div>
          <div class="value">¥{{orderobj.totalAmount}}</div>
        </div>
        <div class="item">
          <div class="label">退款单号</div>
          <div class="value">{{orderobj.refundNo==null?'':orderobj.refundNo}}</div>
        </div>
        <div class="item">
          <div class="label">申请时间</div>
          <div class="value">{{orderobj.applyDate}}</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DeliveryRules",
  data() {
    return {
      status: 1,
      refoundIndex: 0,
      API: this.$store.state.API,
      refundList_new: [],
      orderobj: null,
      refunddate: "",
      showRefoundInfo_new:false,
      type: ""
    };
  },
  props: {
    showRefoundInfo: {
      type: Boolean,
      default: false
    },
    refundList: {
      type: Array,
      default: []
    }
  },
  watch: {
    refundList: {
      immediate: true,
      handler(curVal, oldVal) {
        this.refundList_new = curVal;
        this.getRefundDetail(curVal[0]);
      },
      deep: true //true 深度监听
    },
    showRefoundInfo:{
      handler(curVal, oldVal){
        if(curVal){
          this.getRefundDetail(this.refundList_new[0]);
        }
        this.showRefoundInfo_new=curVal
      }
    }
  },
  components: {},
  methods: {
    changePackage(index, id) {
      this.refoundIndex = index;
      this.getRefundDetail(id);
    },
    async getRefundDetail(id) {
      let url = this.API.order.refundDetail;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        orderSkuItemRefundId: id,
        openId: OpenId || this.$store.state.userId
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.orderobj = res.data.returnData.refundOrderItemListVo;
            this.refunddate =
              res.data.returnData.refundOrderItemListVo.successDate;
            this.type = res.data.returnData.type;
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    close() {
      this.refoundIndex=0;
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}

/deep/.rules-modal .ivu-modal-content {
  min-height: 40rem;
  padding: 2rem 2rem;
  margin: auto;
  display: flex;
  justify-content: space-around;
  color: #5c5d5f;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  .header {
    margin-bottom: 1.5rem;
    text-align: left;
    i {
      float: right;
      font-size: 1.6rem;
      color: #000000;
      margin-top: -0.4rem;
      margin-right: -0.4rem;
      cursor: pointer;
      font-weight: 500;
      // margin-top: -1px;
    }
  }
  .package-info {
    margin-bottom: 2rem;
    .package-list {
      display: flex;
      flex-direction: row;
      .package {
        cursor: pointer;
        padding: 2rem 4rem 2rem 0;
        color: #959595;
        &.active {
          color: #5c5d5f;
        }
        span {
          padding: 0 0.3rem;
        }
      }
    }

    .content {
      border: 0.1rem solid #eaeaea;
      padding: 2rem;
      .status {
        padding-bottom: 0.8rem;
        .status-icon {
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }
  .good-list {
    border: 0.1rem solid #eaeaea;
    padding-top: 2rem;
    .cart-item {
      // border: 0.1rem solid #eaeaea;
      // padding-top: 2rem;
    }
  }
  .refound-info {
    border: 0.1rem solid #eaeaea;
    padding: 2rem;
    margin-top: 2rem;
    .item {
      display: flex;
      justify-content: space-between;
      line-height: 2rem;
    }
  }
}
/deep/.rules-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  font-size: 1.2rem;
  width: 100%;
}

/deep/.ivu-modal {
  margin: 10px 0;
}
@media screen and (max-width: 1024px) {
  /deep/.rules-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .rules-modal .ivu-modal-content {
    width: 100%;
    padding: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/RefoundInfoPop.vue